<template>
	<div>

		<div class="card shadow-sm mb-4">
			<div class="card-header">
				<button class="btn btn-light" style="position: absolute; right: 0.5em; top: 0.5em;" @click.prevent="refreshCollection"><i class="fas fa-sync-alt"></i> Refresh</button>
				<h4 class="my-0 font-weight-normal">Collection Settings</h4>
			</div>
			<div class="card-body">
				<form autocomplete="off">
					<div class="form-group">
						<label for="collectionSettings_title">Title</label>
						<input v-model="collectionSettings.title" type="text" class="form-control" id="collectionSettings_title" aria-describedby="collectionSettings_titleHelp" placeholder="Enter title">
						<small id="collectionSettings_titleHelp" class="form-text text-muted">Title (name) for this Collection (e.g. "Store Products")</small>
					</div>
					<div class="form-group">
						<label for="collectionSettings_desc">Description</label>
						<textarea v-model="collectionSettings.description" type="text" class="form-control" id="collectionSettings_desc" aria-describedby="collectionSettings_descHelp" placeholder="Enter description" rows="2"></textarea>
						<small id="collectionSettings_descHelp" class="form-text text-muted">Descriptive details (e.g. "This collection stored product entries.")</small>
					</div>

					<div class="form-group">
						<label for="collectionSettings_group">Collection Group (Optional)</label>
						<input v-model="collectionSettings.group" type="text" class="form-control" id="collectionSettings_group" aria-describedby="collectionSettings_groupHelp" placeholder="Enter group name (optional)">
						<small id="collectionSettings_groupHelp" class="form-text text-muted">This will be used to organize collections into groups (e.g. "Site Content")</small>
					</div>

					<template v-if="collectionSettings.$schema && collectionSettings.$schema.endsWith('reference.')">
						<h5 class="font-weight-normal">Reference Settings</h5>

						<div class="form-group">
							<label for="collectionSettings_id">Source Collection</label>
							<input v-model="collectionSettings.source" type="text" class="form-control" id="collectionSettings_source" aria-describedby="collectionSettings_sourceHelp" placeholder="<node-id>/<project>:<collection>">
							<small id="collectionSettings_sourceHelp" class="form-text text-muted">Collection address (global, project or local)</small>
						</div>
						<div class="form-group">
							<label for="collectionSettings_key">Reference Key (API Key)</label>
							<input v-model="collectionSettings.key" type="text" class="form-control" id="collectionSettings_key" aria-describedby="collectionSettings_keyHelp" placeholder="Enter reference API key">
							<small id="collectionSettings_keyHelp" class="form-text text-muted">Provide an API key which has access to the source collection.</small>
						</div>
					</template>

					<div class="mb-3" v-if="collectionSettings.$schema && collectionSettings.$schema.indexOf('.reference.') < 0">
						<h5 class="font-weight-normal">Schema Settings</h5>
						
						<div class="form-check">
							<input v-model="allowAllSchemas" type="checkbox" class="form-check-input" id="schemaRules_any">
							<label class="form-check-label" for="schemaRules_any">Allow ANY Schema <small class="text-muted">(this also allows objects with no schema at all)</small></label>
						</div>
						
						<div class="mt-2 pl-4" v-if="!allowAllSchemas">
							<h6>Enable Specific Base Schemas</h6>
							<!-- <div class="form-check mt-2">
								<input v-model="schemaRules['']" type="checkbox" class="form-check-input" id="schemaRules_none">
								<label class="form-check-label" for="schemaRules_none"><strong><em class="text-danger">none</em></strong> <small class="text-muted">(allow unstructured "schemaless" objects, to be stored)</small></label>
							</div> -->
							<div v-if="schema.$id.split('.').length <= 2" v-for="(schema,index) in schemaList" :key="index" class="form-check">
								<input v-model="schemaRules[schema.$id.split(':')[1]]" type="checkbox" class="form-check-input" :id="'schemaRules_'+index">
								<label class="form-check-label" :for="'schemaRules_'+index">
									<strong>{{schema.$id.split(/\.|:/g)[1]}}</strong>
									<small class="text-muted">(allow this schema and all that are derived from it)</small>
								</label>
							</div>
						</div>
						
					</div>

					<button class="btn btn-success mt-4" @click.prevent="saveCollectionSettings"><i class="fas fa-save"></i> Save Settings</button>
					<button class="btn btn-secondary mt-4" @click.prevent="resetCollection"><i class="fas fa-sync-alt"></i> Reset Editor</button>
					<button class="btn btn-danger float-right mt-4" @click.prevent="deleteThisCollection"><i class="fas fa-times"></i> Delete Collection</button>
				
					<hr>
					<div class="text-muted">
						<span class="text-danger">UPCOMING:</span> All other collection settings/configs, for example:
						<ol>
							<li>Storage index configs</li>
							<li>Object ID generation options</li>
							<li>Other storage options like default values, date formats, etc.</li>
							<li>Storage targets (FUTURE)</li>
							<li>Custom storage collection name (for underlying table/collection)</li>
						</ol>
					</div>

				</form>

				<hr>

				<router-link tag="button" class="btn btn-primary" :to="'/nodes/'+ nodeId +'/projects/'+ projectId +'/collections/'+ collectionName +'/objects'">Manage Objects</router-link>

			</div>
		</div>

		<div class="card shadow-sm">
			<div class="card-header">
				<h4 class="my-0 font-weight-normal">Collection Settings (JSON)</h4>
			</div>
			<div class="card-body">
				<div id="editor"></div>
				<button class="btn btn-success mt-4" @click.prevent="saveEditorCollection"><i class="fas fa-save"></i> Save Settings</button>
				<button class="btn btn-secondary mt-4" @click.prevent="resetCollection"><i class="fas fa-sync-alt"></i> Reset Editor</button>
			</div>
		</div>
	</div>
</template>

<script>
import 'ace-builds';
import 'ace-builds/webpack-resolver';

import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import _ from 'lodash';

const DEFAULTS_SETTINGS = {
	// TODO
};

export default {
	name: "collection-dashboard",
	props: [ 'nodeId', 'projectId', 'collectionName' ],
	data() {
		return {
			collectionSettings: { },
			schemaRules : { },
			allowAllSchemas : undefined,
		};
	},
	watch:
	{
		allowAllSchemas( newVal, oldVal )
		{
			if( newVal != oldVal && newVal )
				this.$set( this.collectionSettings, 'schemas', { $delete : true } );
			else
				this.updateSchemaRules( this.schemaRules );
		},
		schemaRules:
		{
			deep : true,
			handler : function( newVal, oldVal )
			{
				this.updateSchemaRules( newVal )
			}
		},
		collectionSettings:
		{
			deep: true,
			handler: function( newValue, oldValue )
			{
				// TODO

				this.setEditorCollection( );
			}
		}
	},
	computed:
	{
		schemaList( )
		{
			return this.schemas( this.nodeId, this.projectId );
		},
		...mapGetters( "schemas", {
			schemas: "schemas", // map STATE schemas/schemas to "schemas" AS A FUNCTION, which requires the nodeId and projectId as inputs!
		}),
	},
	methods:
	{
		updateSchemaRules( newRules )	// Called when an update is made on the INTERFACE.
		{
			this.$set( this.collectionSettings, 'schemas', { $delete : true } );
				
			if( this.allowAllSchemas !== true )
			{
				const updatedRules = {};
				for( let match in newRules )
				{
					if( newRules[match] === true )
						updatedRules[match] = { allow : true };
				}
				if( Object.keys( updatedRules ).length > 0 )
				{
					updatedRules.$new = true;
					this.$set( this.collectionSettings, 'schemas', updatedRules );
				}
			}
			this.setEditorCollection( );
		},
		setSchemaRules( rules )	// INITIAL set only, from the original collection data.
		{
			this.allowAllSchemas = !rules;
			if( this.allowAllSchemas )
				return;

			const newRules = { };
			for( let i = 0; i < this.schemaList.length; i++ )
			{
				console.log
				const schema = this.schemaList[i];
				if( schema.$id.split('.').length > 2 )
					continue;
				const match = schema.$id.split( ':' )[1];
				const rule = rules[match];
				if( rule && rule.allow )
					newRules[match] = true;
			}

			this.schemaRules = newRules;
		},
		getSchemas( )
		{
			return this.schemas( this.nodeId, this.projectId );
		},
		async refreshCollection( )
		{
			// TODO: Start Loading
			await this.readCollection( { nodeId : this.nodeId, projectId : this.projectId, collectionName : this.collectionName, nocache : true } );
			this.resetCollection( );
			this.setSchemaRules( this.collectionSettings.schemas );
			// TODO: End Loading
		},
		resetCollection( )
		{
			this.collectionSettings = _.defaultsDeep( _.cloneDeep( this.getCollection( ) ), DEFAULTS_SETTINGS );

			// TODO
		},
		async deleteThisCollection( )
		{
			if( !confirm( "Are you sure you want to delete this collection?" ) )
				return;
			try {
				let result = await this.deleteCollection( { nodeId : this.nodeId, projectId : this.projectId, collectionName : this.collectionName } );
				if( !result )
					console.warn( "[CollectionDashboard] Collection was not found at deletion! Redirecting to Collections listing anyway." );
				this.$router.push( { name : 'collections', params : { nodeId : this.nodeId, projectId : this.projectId } } );
			} catch( err ) {
				console.error( err );
				alert( "Collection could not be deleted!\n"+ err.message );
			}
		},
		getCollection( )
		{
			return this.$store.getters['collections/collection']( this.nodeId, this.projectId, this.collectionName );
		},
		setEditorCollection( collection )
		{
			collection = collection || this.collectionSettings;	//this.$store.state.collections.lookup[this.nodeId][this.projectId][this.collectionName];
			if( collection && this.editor )
			{
				let editorCollection = _.omit( collection, [ '$created', '$modified', '$version', '$node' ] );
				this.editor.setValue( JSON.stringify( editorCollection, null, 2 ), -1 );
			}
		},
		async saveCollectionSettings( )
		{
			let collection = this.collectionSettings;

			if( !collection.group )
				collection.group = { $delete : true };

			let id = this.getCollection( ).$id;

			try {
				let updates = _.omit( collection, [ '$created', '$modified', '$version', '$node' ] );
				let result = await this.updateCollection( { nodeId : this.nodeId, projectId : this.projectId, collectionName : this.collectionName, updates : updates } );
				if( null === result )
					throw new Error( "This collection is no longer found in the repository!" );
				
				// TODO: close loading overlay

			} catch( err ) {

				// TODO: Switch loading overlay to ERROR overlay.

				console.warn( "Collection save failed:", err );

				// TODO: Set this action, as the result of dismissing the ERROR OVERLAY
				this.$router.push( { name : 'collections', params : { nodeId : this.nodeId, projectId : this.projectId } } );
			}
		},
		async saveEditorCollection( )
		{
			// TODO: Set loading overlay
			let collection;

			try {
				collection = JSON.parse( this.editor.getValue( ) );
			} catch( err ) {
				alert( "Could not save the object:\n"+ err.message );
				console.error( err );
				return;
			}

			try {
				let result = await this.updateCollection( { nodeId : this.nodeId, projectId : this.projectId, collectionName : this.collectionName, updates : collection } );
				if( null === result )
					throw new Error( "This collection is no longer found in the repository!" );
				
				// TODO: close loading overlay

			} catch( err ) {

				// TODO: Switch loading overlay to ERROR overlay.

				console.warn( "Collection save failed:", err );

				// TODO: Set this action, as the result of dismissing the ERROR OVERLAY
				this.$router.push( { name : 'collections', params : { nodeId : this.nodeId, projectId : this.projectId } } );
			}
		},
		...mapActions({
			readCollection: "collections/read",
			updateCollection: "collections/update",
			deleteCollection: "collections/delete",
			listSchemas: "schemas/list",
		}),
	},
	async created( )
	{
	},
	async mounted( )
	{
		try {
			this.editor = ace.edit( "editor", {
				mode: "ace/mode/json",
				theme: "ace/theme/tomorrow",	//"ace/theme/dracula",
				maxLines: 20,
				minLines: 5,
				fontSize: 14,
				showPrintMargin : false
			});
			await this.listSchemas( { nodeId : this.nodeId, projectId : this.projectId, nocache : true } );
			await this.refreshCollection( );
		} catch( err ) { throw err; }
	}
};
</script>
<style scoped>
div#editor
{
	border: 1px solid #666;
}
h2 {
	font-weight: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/CollectionDashboard.vue